/**
 * Normalizes rate input to 2 decimal places
 * @param rateInput The rate input to normalize
 * @returns normalized rate
 */
export const getNormalizedRate = (rateInput: string) => Math.round(parseFloat(rateInput) * 100) / 100;

/**
 * Validates that the rate input string only contains characters for a valid rate.
 * Consumer is responsible for converting the rate input string to a domain acceptable rate using localeRateToDomain.
 * Ex. this function will return true for '12,34' but consumer is responsible for converting it to 12.34.
 * @param rateInput The rate input to validate.
 * @returns True if the rate input is valid, false otherwise.
 */
export const isValidRateInput = (rateInput: string) => {
  // input string contains only number allowed characters
  // Also allow an empty string or user can't clear the input
  const isRateNumber = /^[0-9.,]+$/.test(rateInput) || rateInput === '';

  return isRateNumber;
};
